// extracted by mini-css-extract-plugin
export default {"root":"CommunityOrganizerSettings_root__lGhkt"};